import { Suspense } from 'react';
import * as ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { SupervisorProvider } from './hooks/useSupervisor';
import { supervisorService } from './services/supervisorService';

import App from './App';
import { store, persistor } from './app/store';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from './components/theme/theme-provider';
import { Toaster } from './components/ui/toaster';
import { analytics } from './services/analytics';
import { logging } from './services/logging';
import './i18n';
import './index.css';

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  analytics.init({
    appVersion: import.meta.env.VITE_APP_VERSION,
    appName: import.meta.env.VITE_APP_NAME,
  });
  logging.init({
    appVersion: import.meta.env.VITE_APP_VERSION,
    appName: import.meta.env.VITE_APP_NAME,
  });

  root.render(
    <Provider store={store}>
      <PersistGate loading={<div>Loading persisted state...</div>} persistor={persistor}>
        <BrowserRouter>
          <ThemeProvider attribute="class" defaultTheme="light" enableSystem storageKey="vite-ui-theme">
            <Suspense fallback={<div>Loading...</div>}>
              <SupervisorProvider value={supervisorService}>
                <App />
                <Toaster />
              </SupervisorProvider>
            </Suspense>
          </ThemeProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}
